import { ICorporatePartner } from './corporate-partner.interface';

export class Kayak4Business implements ICorporatePartner {
  public name = 'kayak4biz';
  public displayBusinessLogo = true;
  public updateBgColor = true;
  public restrictPaxToOne = false;
  public disableMiles = true;
  public displayInlineText = 'default';
  public showPopupForEcert = false;
  public showBusinessText = false;
  public showBusinessMilesLabel = false;
}
